
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ShortcutPanelCard',
})
class ShortcutPanelCard extends Vue {
  @Prop({ required: true })
  private readonly card: any;

  get contentColorString(): any {
    const styleString =
      `color: ${this.card.contentColor} !important`;

    return styleString;
  }

  private redirectOnClick() {
    const link = this.card.link;

    if (link) {
      this.$router.push(this.card.link);
    }
  }
}

export default ShortcutPanelCard;
